import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import '../stylesheets/ConfirmModal.css';

const AskModal = ({message, onConfirm, onCancel}) => {
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    
    return (<div className="modal ask-modal" id="confirm_modal">
        <div className="modal-body" id="confirm_modal_body">
            <div className="modal-content">
                <div className="modal-header">
                    <span>{strings.are_you_sure}</span>
                    <hr/>
                </div>
                <div className="modal-title">{message}</div>
                <button className="btn cancel" onClick={event => {
                event.preventDefault();
                onCancel();
            }}>{strings.no}</button>
                <button className="btn" onClick={event => {
                event.preventDefault();
                onConfirm();
            }}>{strings.yes}</button>
    
            </div>
        </div>
    </div>);
};

export default AskModal;